import { forwardRef } from "react";
import GaborGrangerPlot from "../gabor-granger-plot/gabor-granger-plot.component";
import LinePlot from "../line-plot/line-plot.component";
import BarPlot from "../bar-plot/bar-plot.component";
import { isEmpty } from "../../assets/constants";

const SocialCard = forwardRef(({
    surveyResponse,
    isSmall,
    isMedium,
    width,
    height,
    margins,
    hideAxisLabels,
    surveyType,
}, containerRef) => {

    const innerWidth = width - (margins.left + margins.right);
    const innerHeight = height - (margins.top + margins.bottom);
    const dimensions = { width, height, innerWidth, innerHeight, margins }
    const isPanel = surveyResponse.surveyYears && surveyResponse.surveyYears[0] !== surveyResponse.surveyYears[1];

    if (isEmpty(surveyResponse)) return null;

    const containerStyles = {
        position: 'absolute',
        top: `-${height}px`,
        left: `200vw`,
        // top: 200,
        // left: 0,
        width: `${width}px`,
        height: `${height}px`,
        background: 'white',
        zIndex: '99999',
        border: '1px solid black',
    }

    return (
        <div ref={containerRef} style={containerStyles}>
            {
                surveyResponse.surveyType === 'GGS' ?
                    <GaborGrangerPlot
                        dimensions={dimensions}
                        surveyResponse={surveyResponse}
                        isSmall={isSmall}
                        isMedium={isMedium}
                        hasMouse={false}
                        animateTransition={false}
                    />
                    :
                    isPanel ?
                        <LinePlot
                            dimensions={dimensions}
                            surveyResponse={surveyResponse}
                            isSmall={isSmall}
                            isMedium={isMedium}
                            animateTransition={false}
                            hasMouse={false}
                            plotType='estimated'
                            hideAxisLabels={hideAxisLabels}
                            clipPathId={`social-line-${width}-${height}`}
                        />
                        :
                        <BarPlot
                            dimensions={dimensions}
                            surveyResponse={surveyResponse}
                            isSmall={isSmall}
                            isMedium={isMedium}
                            animateTransition={false}
                            hasMouse={false}
                            plotType='estimated'
                            hideAxisLabels={hideAxisLabels}
                            clipPathId={`social-bar-${width}-${height}`}
                        />
            }
        </div>
    )
});

export default SocialCard;